export type Mode = 'single' | 'album';
export type Track = 1 | 2 | 3;
export type PatternName = 'corners' | 'plus' | 'x' | 'arrow' | 'diamond' | 't' | 'box';

/** Track 2 "Remix" patterns: row-major cell indexes 0-24, centre 12 is the free star. */
export const PATTERNS: Record<PatternName, { label: string; cells: readonly number[] }> = {
  corners: { label: '4 Corners', cells: [0, 4, 12, 20, 24] },
  plus: { label: 'Plus', cells: [2, 7, 10, 11, 12, 13, 14, 17, 22] },
  x: { label: 'X', cells: [0, 4, 6, 8, 12, 16, 18, 20, 24] },
  arrow: { label: 'Arrow', cells: [2, 6, 7, 8, 10, 12, 14, 17, 22] },
  diamond: { label: 'Diamond', cells: [2, 6, 8, 10, 14, 16, 18, 22] },
  t: { label: 'T', cells: [0, 1, 2, 3, 4, 7, 12, 17, 22] },
  box: { label: 'Small Box', cells: [6, 7, 8, 11, 12, 13, 16, 17, 18] },
};

export const TRACK_POINTS: Record<Track, number> = { 1: 5, 2: 10, 3: 15 };
export const TRACK_NAMES: Record<Track, string> = { 1: 'BANGER!', 2: 'The Remix', 3: 'PLATINUM!' };

export const ALBUM_MIN_DECADES = 3;
export const ALBUM_MIN_SONGS = 60;
export const DEFAULT_MODE: Mode = 'single';
